import React from 'react';
import { motion } from 'framer-motion';
import { schedule, pets } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

export default function Schedule() {
  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-slate-800 tracking-tight">Mission Timeline</h1>
        <p className="text-slate-500 mt-1">Today's scheduled operations.</p>
      </header>

      <div className="bg-white/80 backdrop-blur-xl rounded-3xl p-6 md:p-8 shadow-[0_8px_32px_rgba(0,0,0,0.04)] border border-white">
        <div className="relative border-l-2 border-[#F5EFE6] ml-4 md:ml-6 space-y-8 pb-4">
          {schedule.map((item, index) => {
            const pet = pets.find(p => p.id === item.petId);
            return (
              <motion.div 
                key={item.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="relative pl-8 md:pl-10"
              >
                {/* Timeline dot */}
                <div className={`absolute -left-[11px] top-1 w-5 h-5 rounded-full border-4 border-white ${
                  item.completed ? 'bg-[#0047AB]' : 'bg-[#FF7F50]'
                } shadow-sm`} />
                
                <div className={`bg-white p-5 rounded-2xl border transition-all ${
                  item.completed ? 'border-slate-100 opacity-70' : 'border-[#0047AB]/10 shadow-md hover:shadow-lg'
                }`}>
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-xl ${
                        item.completed ? 'bg-slate-50 text-slate-400' : 'bg-[#F5EFE6] text-[#0047AB]'
                      }`}>
                        <SafeIcon icon={item.icon} />
                      </div>
                      <div>
                        <h3 className={`font-bold text-lg ${item.completed ? 'text-slate-500 line-through' : 'text-slate-800'}`}>
                          {item.title}
                        </h3>
                        <div className="flex items-center gap-2 mt-1 text-sm text-slate-500">
                          <SafeIcon icon="FiClock" />
                          <span>{item.time}</span>
                          {pet && (
                            <>
                              <span className="w-1 h-1 bg-slate-300 rounded-full mx-1" />
                              <span className="flex items-center gap-1">
                                <img src={pet.image} alt={pet.name} className="w-4 h-4 rounded-full object-cover" />
                                {pet.name}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    {!item.completed && (
                      <button className="self-start md:self-center px-4 py-2 bg-[#0047AB]/5 hover:bg-[#0047AB]/10 text-[#0047AB] font-semibold rounded-xl transition-colors flex items-center gap-2">
                        <SafeIcon icon="FiCheck" />
                        Complete
                      </button>
                    )}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}